import { Component } from '@angular/core';

@Component({
  selector: 'isd-file-transfer-wrapper',
  templateUrl: './file-transfer-wrapper.component.html',
  styleUrls: ['./file-transfer-wrapper.component.scss']
})
export class FileTransferWrapperComponent {}
